(function ($) {

    // Comportamento do formulário "Solicitar Cotação" (rodapé/contato).
    // - Toggle de blocos PF/PJ via radio [name="for-type"]
    // - Máscara + validação algorítmica do CNPJ
    // - Consulta BrasilAPI (via AJAX WP) + auto-preenche Nome da Empresa
    //
    // Depende de: jQuery, jquery.mask, mpCnpj (localizado pelo PHP).

    var SELECTOR_FORM   = '.wpcf7-form';
    var SELECTOR_TYPE   = 'input[name="for-type"]';
    var SELECTOR_CNPJ   = 'input[name="for-cnpj"]';
    var SELECTOR_COMP   = 'input[name="for-company"]';
    var CLASS_LOADING   = 'is-loading';
    var CLASS_VALID     = 'is-valid';
    var CLASS_INVALID   = 'is-invalid';
    var CLASS_ACTIVE    = 'is-active';
    var MASK_CNPJ       = '00.000.000/0000-00';

    function digitsOnly(value) {
        return String(value || '').replace(/\D+/g, '');
    }

    function isValidAlgorithm(cnpj) {
        cnpj = digitsOnly(cnpj);
        if (cnpj.length !== 14) return false;
        if (/^(\d)\1{13}$/.test(cnpj)) return false;

        function calc(partial) {
            var len     = partial.length;
            var weights = len === 12
                ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
                : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
            var sum = 0;
            for (var i = 0; i < len; i++) {
                sum += parseInt(partial.charAt(i), 10) * weights[i];
            }
            var mod = sum % 11;
            return mod < 2 ? 0 : 11 - mod;
        }

        var base = cnpj.substring(0, 12);
        var d1   = calc(base);
        var d2   = calc(base + d1);
        return parseInt(cnpj.charAt(12), 10) === d1
            && parseInt(cnpj.charAt(13), 10) === d2;
    }

    function setState($field, state) {
        var $group = $field.closest('.field-group');
        $group.removeClass(CLASS_LOADING + ' ' + CLASS_VALID + ' ' + CLASS_INVALID);
        if (state) $group.addClass(state);
    }

    function fillCompany($form, value) {
        var $company = $form.find(SELECTOR_COMP);
        if (!$company.length) return;
        $company.val(value || '');
    }

    function getSelectedType($form) {
        return $form.find(SELECTOR_TYPE + ':checked').val() || '';
    }

    function applyToggle($form) {
        var type     = getSelectedType($form);
        var isPJ     = type === 'Empresa';
        var isPF     = type === 'Pessoa Física';
        var $pfNodes = $form.find('[data-mode="pf"]');
        var $pjNodes = $form.find('[data-mode="pj"]');

        $pfNodes.toggleClass(CLASS_ACTIVE, isPF);
        $pjNodes.toggleClass(CLASS_ACTIVE, isPJ);

        // Limpa estados ao trocar de modo
        if (!isPJ) {
            var $cnpj = $form.find(SELECTOR_CNPJ);
            if ($cnpj.length) {
                setState($cnpj, '');
                fillCompany($form, '');
            }
        }
    }

    function validateCnpjField($field) {
        var $form = $field.closest(SELECTOR_FORM);
        var type  = getSelectedType($form);
        if (type !== 'Empresa') return;

        var raw = digitsOnly($field.val());
        if (raw === '') {
            setState($field, '');
            fillCompany($form, '');
            return;
        }

        if (!isValidAlgorithm(raw)) {
            setState($field, CLASS_INVALID);
            fillCompany($form, '');
            return;
        }

        setState($field, CLASS_LOADING);

        $.ajax({
            url: mpCnpj.ajaxUrl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'mp_validate_cnpj',
                nonce:  mpCnpj.nonce,
                cnpj:   raw
            }
        }).done(function (response) {
            if (response && response.success && response.data) {
                var razao = response.data.razao_social || response.data.nome_fantasia || '';
                setState($field, CLASS_VALID);
                fillCompany($form, razao);
            } else {
                setState($field, CLASS_INVALID);
                fillCompany($form, '');
            }
        }).fail(function () {
            setState($field, CLASS_INVALID);
            fillCompany($form, '');
        });
    }

    function initForm(form) {
        var $form = $(form);
        if (!$form.find(SELECTOR_TYPE).length) return;

        // Máscara CNPJ
        var $cnpj = $form.find(SELECTOR_CNPJ);
        if ($cnpj.length && $.fn.mask) {
            $cnpj.mask(MASK_CNPJ);
        }

        // Toggle inicial
        applyToggle($form);

        $form.on('change', SELECTOR_TYPE, function () {
            applyToggle($form);
        });

        $form.on('blur', SELECTOR_CNPJ, function () {
            validateCnpjField($(this));
        });

        // Garante revalidação ao tentar submeter
        $form.on('submit', function () {
            var type = getSelectedType($form);
            if (type === 'Empresa') {
                validateCnpjField($form.find(SELECTOR_CNPJ));
            }
        });
    }

    $(function () {
        $(SELECTOR_FORM).each(function () { initForm(this); });
    });

})(jQuery);
